module.exports = __webpack_public_path__ + "static/media/x.c5db13b2.svg";